import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from './api';
import { AuthService } from './auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService extends Api {
    constructor(
        httpClient: HttpClient,
        authService: AuthService,
    ) {
        super(httpClient, authService, '');
    }
}